import React from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { PageHeader, ResponsiveTable, TableSkeleton, EmptyState, DateCell, StatusBadge, AutoBadge, SectionCard } from "@/admin/ui";

export default function AdminRefunds() {
  const { t } = useLang();
  const [refunds, setRefunds] = React.useState(null);
  const [disputes, setDisputes] = React.useState(null);
  React.useEffect(() => {
    api.get("/api/admin/refunds").then((r) => setRefunds(r.data.items));
    api.get("/api/admin/disputes").then((r) => setDisputes(r.data.items));
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-refunds-page">
      <PageHeader title={t("admin.refunds.title")} description={t("admin.refunds.subtitle")} />

      <SectionCard title="Refunds">
        {!refunds ? <TableSkeleton rows={4} cols={6} /> : refunds.length === 0 ? (
          <EmptyState title={t("admin.refunds.empty")} />
        ) : (
          <ResponsiveTable minWidth={900}>
            <thead className="lp-table-sticky"><tr>
              <th>{t("admin.refunds.col.at")}</th>
              <th>{t("admin.refunds.col.user")}</th>
              <th className="text-right">{t("admin.refunds.col.amount")}</th>
              <th>{t("admin.refunds.col.status")}</th>
              <th>{t("admin.refunds.col.ref")}</th>
              <th>{t("admin.refunds.col.reason")}</th>
            </tr></thead>
            <tbody>
              {refunds.map((r) => (
                <tr key={r.id}>
                  <td><DateCell value={r.created_at} /></td>
                  <td className="text-white/80 font-mono text-xs">{r.user_id?.slice(0, 12)}…</td>
                  <td className="text-right text-white/90 tabular-nums">${r.amount.toFixed(2)} {r.currency}</td>
                  <td><AutoBadge value={r.status} /></td>
                  <td className="font-mono text-xs">{r.creem_refund_id}</td>
                  <td className="text-white/60 text-xs max-w-[240px] truncate">{r.reason || "—"}</td>
                </tr>
              ))}
            </tbody>
          </ResponsiveTable>
        )}
      </SectionCard>

      {disputes && disputes.length > 0 && (
        <SectionCard title="Disputes / chargebacks">
          <ResponsiveTable minWidth={700}>
            <thead className="lp-table-sticky"><tr>
              <th>Date</th><th>User</th><th className="text-right">Amount</th><th>Status</th><th>Ref</th>
            </tr></thead>
            <tbody>
              {disputes.map((d) => (
                <tr key={d.id}>
                  <td><DateCell value={d.created_at} /></td>
                  <td className="text-white/80 font-mono text-xs">{d.user_id?.slice(0, 12)}…</td>
                  <td className="text-right tabular-nums">${d.amount.toFixed(2)}</td>
                  <td><StatusBadge tone="warning">{d.status}</StatusBadge></td>
                  <td className="font-mono text-xs">{d.creem_dispute_id}</td>
                </tr>
              ))}
            </tbody>
          </ResponsiveTable>
        </SectionCard>
      )}
    </div>
  );
}
